<template>
  
  <div id="batch-approval-segment" class="ui segment animated fadeIn" style="min-height: 450px;">    
    
    <closeable-header-label label="Aprovar Preços" @onClose="onCancel()"/>

    <div class="ui form m-t-15">
      <div class="inline fields">
        <div class="field">
          <div class="ui radio checkbox batch-approval-checkbox">
            <input type="radio" class="hidden" value="diff" v-model="option">
            <label>% Diferença</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox batch-approval-checkbox">
            <input type="radio" class="hidden" value="discount" v-model="option">
            <label>% Desconto</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox batch-approval-checkbox">
            <input type="radio" class="hidden" value="rg" v-model="option">
            <label>RG</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox batch-approval-checkbox">
            <input type="radio" class="hidden" value="commission" v-model="option">
            <label>% Comissão</label>
          </div>
        </div>
      </div> 
      <div class="fields">
        <div class="three wide field">
          <input :value="inputBatchValue" @blur="inputBatchValue = $event.target.value" placeholder="0,00">
        </div>
      </div>
      <div class="fields">
        <div class="five wide field">
          <label class="form-label">Produto</label>
          <select id="selectBatchProduct" class="ui fluid dropdown" v-model="selectedProduct">
            <option value="">Todos</option>
            <option v-for="product in products" :value="product.id">{{ product.name }}</option>
          </select>
        </div>
        <div class="five wide field">
          <label class="form-label">Bitola</label>
          <select id="selectBatchBitola" class="ui fluid dropdown" v-model="selectedBitola">
            <option value="">Todas</option>
            <option v-for="bitola in bitolas" :value="bitola.id">{{ bitola.name }}</option>
          </select>
        </div>
        <div class="five wide field">
          <label class="form-label">Acondicionamento</label>
          <select id="selectBatchPackage" class="ui fluid dropdown" v-model="selectedPackage">
            <option value="">Todos</option>
            <option v-for="pack in packages" :value="pack.id">{{ pack.name }}</option>
          </select>
        </div>
      </div>
      <div class="inline fields m-t-20">
        <div class="field">
          <div class="ui radio checkbox batch-approval-checkbox">
            <input type="radio" class="hidden" value="only_not_approved" v-model="filter">
            <label>Somente não aprovados</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox batch-approval-checkbox">
            <input type="radio" class="hidden" value="all" v-model="filter">
            <label>Todos os itens</label>
          </div>
        </div>
      </div>
    </div>

    <div style="margin-top: 25px; margin-bottom: 25px;" v-html="infoLabel"></div>

    <button class="ui button m-b-15" :class="{ disabled: !canConfirm, loading }" @click="onConfirm()">
      <i class="checkmark blue icon"></i> Confirmar        
    </button>

    <product-segment v-for="item in itemsPreview" :key="item.item" :quotation="quotation" :item="item" readonly="true" />        

    <div class="ui divider" style="margin-top: 50px !important;"></div>

    <button class="ui basic button m-t-15" @click="onCancel()">
      <i class="reply icon"></i> Cancelar
    </button>

  </div>

</template>

<script>

  import _ from "underscore"
  import { AppBrowser, Input, Loader, Scroll } from "@/utils"
  import QuotationService from "@/services/quotation-service"
  import CloseableHeaderLabel from "@/components/closeable-header-label.vue"
  import ProductSegment from "./product-segment.vue"

  export default {

    data() {
      return {
        loading: false,
        option: "",
        batchValue: 0,
        selectedProduct: "",
        selectedBitola: "",
        selectedPackage: "",
        filter: "",
      }
    },

    props: ["quotation"],
    
    components: {
      CloseableHeaderLabel,
      ProductSegment,
    },

    computed: {

      inputBatchValue: {
        get() {
          return Input.currencyToString(this.batchValue) 
        },
        set(value) {
          this.batchValue = Input.stringToCurrency(value)          
        },
      },

      products() {        

        let products = []
        let productIds = []

        this.quotation.items.forEach((item) => {

          const isSameBitola = (item.codeBitola === this.selectedBitola)
          const isSamePackage = (item.idPackage === this.selectedPackage)
          let shouldAddThisItem = (productIds.toString().indexOf(item.codeName) === -1)

          if (shouldAddThisItem && this.selectedBitola && !isSameBitola)
            shouldAddThisItem = false

          if (shouldAddThisItem && this.selectedPackage && !isSamePackage)
            shouldAddThisItem = false

          if (shouldAddThisItem) {
            productIds.push(item.codeName)
            products.push({ id: item.codeName, name: item.name })
          }
        })

        return _.sortBy(products, "name")        
      },

      bitolas() {

        let bitolas = []
        let bitolaIds = []

        this.quotation.items.forEach((item) => {	

          const isSameProduct = (item.codeName === this.selectedProduct)
          const isSamePackage = (item.idPackage === this.selectedPackage)
          let shouldAddThisItem = (bitolaIds.toString().indexOf(item.codeBitola) === -1)

          if (shouldAddThisItem && this.selectedProduct && !isSameProduct)
            shouldAddThisItem = false

          if (shouldAddThisItem && this.selectedPackage && !isSamePackage)
            shouldAddThisItem = false

          if (shouldAddThisItem) {
            bitolaIds.push(item.codeBitola)
            bitolas.push({ id: item.codeBitola, name: item.bitola })
          }
        })

        return _.sortBy(bitolas, "id")
      },

      packages() {

        let packs = []
        let packIds = []

        this.quotation.items.forEach((item) => {	

          const isSameProduct = (item.codeName === this.selectedProduct)
          const isSameBitola = (item.codeBitola === this.selectedBitola)
          let shouldAddThisItem = (packIds.toString().indexOf(item.idPackage) === -1)

          if (shouldAddThisItem && this.selectedProduct && !isSameProduct)
            shouldAddThisItem = false

          if (shouldAddThisItem && this.selectedBitola && !isSameBitola)
            shouldAddThisItem = false

          if (shouldAddThisItem) {
            packIds.push(item.idPackage)
            packs.push({ id: item.idPackage, name: item.package })
          }
        })

        return _.sortBy(packs, "name")
      },

      infoLabel() {

        if (!this.option || !this.filter)
          return ""

        const isPriceDiff = (this.option == "diff")
        const isDiscount = (this.option == "discount")
        const isCommission = (this.option == "commission")
        const isRg = (this.option == "rg")        
        const isOnlyNotApproved = (this.filter == "only_not_approved")
        const isAllItems = (this.filter == "all")

        if (isCommission && this.batchValue < 0)    
          return '<i class="exclamation circle red icon"></i> A comissão não pode ser negativa'

        let html = '<i class="info circle blue icon"></i>'
        
        const value = Input.currencyToString(this.batchValue) || "0,00"

        html += "Definir <strong>" + value

        if (!isRg)
          html += "%"

        html += " de "

        if (isPriceDiff) {		
          html += "Diferença entre o Preço Sugerido e o Preço Aprovado</strong> para todos os itens"		
        } else if (isDiscount) {		
          html += "Desconto em relação ao Preço Mínimo</strong> para todos os itens"
        } else if (isCommission) {		
          html += "Comissão Aprovada</strong> para todos os itens"
        } else if (isRg) {		
          html += "RG</strong> para todos os itens"
        }

        if (!this.selectedProduct && !this.selectedBitola && !this.selectedPackage) {

          html += " desse orçamento"

        } else {

          if (this.selectedProduct)
            html += " da família <strong>" + $("#selectBatchProduct option:selected").text().trim() + "</strong>"

          if (this.selectedBitola) {

            if (this.selectedProduct)				
              html += ","

            html += " com bitola <strong>" + $("#selectBatchBitola option:selected").text().trim() + "</strong>"
          }

          if (this.selectedPackage) {

            if (this.selectedProduct || this.selectedBitola) {
              html += " e"
            } else {
              html += " com"
            }	

            html += " acondicionamento <strong> " + $("#selectBatchPackage option:selected").text().trim() + "</strong>"
          }			
        }

        if (isOnlyNotApproved) {
          html += " que ainda não foram aprovados."
        } else if (isAllItems) {
          html += "."
        }

        return html
      },

      canConfirm() {
        return (this.option && this.filter)
      },

      itemsPreview() {

        if (!this.filter)
          return []

        let preview = []
        const items = _.sortBy(this.quotation.items, "description")

        items.forEach((item) => {
          if (this.showItem(item))
            preview.push(item)
        })

        return preview
      },
    },    

    mounted() {      
      $(".batch-approval-checkbox").checkbox()
    },

    methods: {

      showItem(item) {

        let show = true
        const onlyNotApproved = (this.filter == "only_not_approved")

        if ( (this.selectedProduct && item.codeName !== this.selectedProduct) || 
             (this.selectedBitola && item.codeBitola !== this.selectedBitola) || 
             (this.selectedPackage && item.idPackage !== this.selectedPackage) ) {

          show = false

        } else if ( onlyNotApproved && item.appPrice > 0 ) {

          show = false
        }		

        return show
      },

      onCancel() {
        this.$emit("onCancel")
      },

      async onConfirm() {

        this.loading = true

        Loader.show()

        try {

          await QuotationService.batchApproval({
            quotationId: this.quotation.id,
            option: this.option,
            value: this.batchValue,
            product: this.selectedProduct,
            bitola: this.selectedBitola,
            package: this.selectedPackage,
            onlyNotApproved: (this.filter == "only_not_approved"),
          })

          this.$emit("onUpdate")

          this.option = ""
          this.batchValue = 0                  

          if (AppBrowser.isMobile())
            Scroll.toElement("#batch-approval-segment")
          
        } catch (error) {
          this.$errorHandler(error)
        }

        this.loading = false

        Loader.hide()
      },
    },
  }
</script>

